import { render, staticRenderFns } from "./AddProductBrandComponent.vue?vue&type=template&id=f5541780&scoped=true"
import script from "./AddProductBrandComponent.vue?vue&type=script&lang=js"
export * from "./AddProductBrandComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5541780",
  null
  
)

export default component.exports